import { GapDensityMapTheme } from "@app/projects/network-assessment/maps/gap-density-map/interfaces";
import {v4 as uuidv4} from 'uuid';

export const GAP_DENSITY_MAP_THEME_MAUVE: GapDensityMapTheme = {
  gapColor1: "#DAC7EC",
  gapColor2: "#BF9EDE",
  gapColor3: "#A478CE",
  gapColor4: "#886AA5",
  name: "Mauve",
  noGapColor: "#F6F0FA",
  uuid: "mauve",
} as const;

export const GAP_DENSITY_MAP_THEME_BOLD: GapDensityMapTheme = {
  gapColor1: "#A9C6F9",
  gapColor2: "#A38ACB",
  gapColor3: "#F86B75",
  gapColor4: "#800020",
  name: "Bold",
  noGapColor: "#504D5C",
  uuid: "bold",
} as const;

export const GAP_DENSITY_MAP_THEME_LUCID: GapDensityMapTheme = {
  gapColor1: "#CCF5E7",
  gapColor2: "#DCECFF",
  gapColor3: "#FFF7DD",
  gapColor4: "#FCD7DD",
  name: "Lucid",
  noGapColor: "#E0E0E0",
  uuid: "lucid",
} as const;

const GAP_DENSITY_MAP_THEME_DEFAULT: GapDensityMapTheme = {
  gapColor1: "#FFFFFF",
  gapColor2: "#FFFFFF",
  gapColor3: "#FFFFFF",
  gapColor4: "#FFFFFF",
  name: "",
  noGapColor: "#FFFFFF",
  uuid: "",
} as const;

export const gapDensityMapThemeDefault = (): GapDensityMapTheme => {
  return {
    ...GAP_DENSITY_MAP_THEME_DEFAULT,
    uuid: uuidv4(),
  };
}

export const GAP_DENSITY_MAP_STYLE = {
  COLOR_NAMES: ["0 Gaps", "Range 1 (Low)", "Range 2", "Range 3", "Range 4 (High)"],
  COUNTY_SERVICING_AREA_LAYER_ID: "county-servicing-area-layer",
  COUNTY_SERVICING_AREA_OUTLINE_COLOR: "white",
  COUNTY_SERVICING_AREA_OUTLINE_LAYER_ID: "county-servicing-area-outline-layer",
  COUNTY_SERVICING_AREA_OUTLINE_WIDTH: 1,
  COUNTY_SERVICING_AREA_SELECTED_OUTLINE_COLOR: "#3388ff",
  COUNTY_SERVICING_AREA_SELECTED_OUTLINE_WIDTH: 2,
  COUNTY_SERVICING_AREA_SOURCE_ID: "county-servicing-area-source",
  GAP_DENSITY_MAP_BOUNDS_PADDING: 50,
  GAP_DENSITY_MAP_PAN_DURATION: 1000,
  GAP_DENSITY_MAP_THEME_COLOR_CIRCLE_BORDER: "1px solid #e8e8e8",
  GAP_DENSITY_MAP_THEME_COLOR_CIRCLE_DIAMETER: "42px",
  NUMBER_OF_BUCKETS: 4,
  NUMBER_OF_BUCKETS_WITH_SPECIALTY: 2,
  QUEST_THEMES: [GAP_DENSITY_MAP_THEME_MAUVE, GAP_DENSITY_MAP_THEME_BOLD, GAP_DENSITY_MAP_THEME_LUCID],
} as const;